<template>
  <div>
    <list
      row-key="SettleId"
      ref="list"
      unit="标签项"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="标签项名称">
          <el-input v-model="params.DataName" placeholder="请输入标签项名称"  clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DataName" label="标签项名称" min-width="120px" />
        <el-table-column prop="DataType" label="标签项类型" align="center" width="120px">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.DataType==0">客户档案</el-tag>
            <el-tag type="success" v-else>其他</el-tag>
          </template>
        </el-table-column>
        
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/sy/enumdata").default,
      params: {
        DataName: "",
       
      },
      
    };
  },
  methods: {
    delRange(row) {
      this.api.delete(row).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>